import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '../../../../../components/Common/UI/Dialog';
import Icons from '../../../../../components/Common/Icons/Icons';
import Separator from '../../../../../components/Common/UI/Separator';
import { Button } from '../../../../../components/Common/UI/Button';
import { cn } from '../../../../../utils/styles';

interface IModalSave {
  trigger: React.ReactNode;
  title: React.ReactNode;
  content?: React.ReactNode;
  cancelText?: string;
  okText?: string;
  contentStyle?: string;
  triggerStyle?: string;
  onOk?: () => void;
  onOpen?: () => void;
}

function ModalSave({
  okText,
  cancelText,
  trigger,
  content,
  title,
  contentStyle,
  triggerStyle,
  onOk,
  onOpen,
}: IModalSave) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Dialog
      open={modalOpen}
      onOpenChange={isOpen => {
        setModalOpen(isOpen);
        if (isOpen && onOpen) onOpen();
      }}
    >
      <DialogTrigger variant="ghost" className={triggerStyle}>
        {trigger}
      </DialogTrigger>
      <DialogContent className={cn('max-h-[98%]', contentStyle)}>
        <DialogTitle className="flex items-center gap-4 mb-[10px]">
          <Icons.SaveFilled className="size-[34px] [&_path]:fill-addition5" />
          {title}
        </DialogTitle>
        {content}
        <Separator className="m-0" />

        <div className="flex justify-end gap-4">
          <Button variant="link" className="py-3 hover:no-underline" onClick={() => setModalOpen(false)}>
            {cancelText}
          </Button>
          <Button
            variant="default"
            className="py-3 !bg-addition5 hover:opacity-85"
            onClick={() => {
              setModalOpen(false);
              if (onOk) onOk();
            }}
          >
            {okText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

ModalSave.defaultProps = {
  cancelText: 'Cancel',
  okText: 'Save',
  content: '',
  contentStyle: '',
  triggerStyle: '',
  onOk: () => undefined,
  onOpen: () => undefined,
};

export default ModalSave;
